import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import Loading from "../spinners/Loading";
import { useDispatch } from "react-redux";
import { setDialog } from "../../features/dialog/dialogSlice";
import ErrorAlert from "../alerts/ErrorAlert";
import { useDeleteDocumentMutation } from "../../features/fileData/fileDataApiSlice";

function FileDataDeleteDialog({ fileData, handleClose }) {
  const dispatch = useDispatch();

  console.log("fileData :>> ", fileData);

  const [deleteDocument, { isLoading, isError }] = useDeleteDocumentMutation();

  const handleDeleteDocument = async () => {
    console.log("test");
    try {
      let result = await deleteDocument(fileData._id).unwrap();
      if (result?.type === "success") {
        dispatch(
          setDialog({
            title: "Dokument wurde erfolgreich gelöscht!",
            type: "SUCCESS",
            data: {
              successText: fileData.fileName + " wurde erfolgreich gelöscht!",
            },
          })
        );
      }
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  return (
    <div>
      <Dialog
        onClose={!isLoading ? () => handleClose() : null}
        open
        maxWidth="lg"
      >
        <DialogTitle>Dokument löschen</DialogTitle>
        <DialogContent>
          {isLoading && (
            <div style={{ minHeight: 300, minWidth: 300 }}>
              <Loading />
            </div>
          )}

          {!isLoading && (
            <div>
              <Typography variant="h4" id="success-dialog-description">
                Möchten Sie dieses Dokument wirklich endültig löschen?
              </Typography>
              <table style={{ fontSize: "120%", textAlign: "left" }}>
                <tr>
                  <th>Dokumentname:</th>
                </tr>
                <tr>
                  <th>{fileData.fileName}</th>
                </tr>
              </table>
            </div>
          )}
          {isError && (
            <ErrorAlert errorMessage="Fehler beim Löschen des Dokuments" />
          )}
        </DialogContent>
        <DialogActions>
          <Button disabled={isLoading} onClick={handleClose} color="primary">
            Beenden
          </Button>
          <Button
            disabled={isLoading}
            onClick={handleDeleteDocument}
            color="error"
            variant="contained"
            autoFocus
          >
            LÖSCHEN
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default FileDataDeleteDialog;

FileDataDeleteDialog.propTypes = {
  fileData: PropTypes.object,
  dialogType: PropTypes.string,
};
